import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Download Istantaneo', 'Nessun Abbonamento', 'Accesso a Vita', 'Garanzia di 7 Giorni'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-103" data-mp="9lbfqzxtf9d2">
      <div className="mx-auto max-w-4xl text-center" data-id="element-104" data-mp="4m8mecr76rkx">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-105" data-mp="4jm4pkalevoz">
          Risolvi un Intero Anno di Lezioni di Inglese in soli{' '}
          <span className="italic text-brand" data-id="element-106" data-mp="nbf0tnkykx0x">5 Minuti</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-107" data-mp="3d2lb3gldnd2t">
          Unisciti a oltre 2.000 insegnanti che hanno smesso di improvvisare.
          Entra in classe con tutto pronto per insegnare, parlare e ispirare.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-108" data-mp="3e9fsjg47kcn9">
          <img src="https://cdn.magicpatterns.com/uploads/uhGzHT9ys2uZ6RwfLc5DSN/8f0cb86b-871b-4d92-8ec8-425bda73a31f.webp" alt="Il pacchetto INGLESE PRONTO: i sei volumi da A1 a C1 con il Master Plan, la piattaforma su desktop, tablet e smartphone e i 5 bonus inclusi" className="mx-auto w-[82%] max-w-lg sm:w-[78%]" data-id="element-109" data-mp="35a2fkdgvl5xs" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-110" data-mp="2lk8uei8o1p2j">
          <CtaButton href="#offer" data-id="element-111" data-mp="n9i3xcn8leu4" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-112" data-mp="ibow6f6accrq">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-113" data-mp="1b0nilohfy12u" data-mpi={index}>
                <span data-id="element-114" data-mp="1ayt7t2zvvpch">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-115" data-mp="162lzj3k0m1rd">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}